module.exports = __webpack_public_path__ + "static/media/bg_trees.078a69e0.jpg";